import { reactive } from '@vue/composition-api';
import { apiEndpoint } from "@/configs/api/api-configs"

export function articleModel() {
    const fetchArticleListModel = reactive({
        api: apiEndpoint.bcrm_platform +'/article/list',
        method: 'POST',
        payload: {
            Page: 1,
            Limit: 10,
            Filters: [],
            Ordering: []
        }
    });
    const fetchArticleDetailModel = reactive({
        api: apiEndpoint.bcrm_platform +'/article/Detail',
        method: 'POST',
        payload: {
            Article_Id: null
        }
    });
    const createArticleModel = reactive({
        api: apiEndpoint.bcrm_platform +'/article/Create',
        method: 'POST',
        payload: {
            Article_Title: null,
            Article_Content_TH: null,
            Article_Content_EN: null,
            Status: null,
            Article_Cover_Url: null,
            Square_Image_Url: null,
            Valid_From: null,
            Valid_From_Time: null,
            Valid_Through: null,
            Valid_Through_Time: null,
            Remark: null,
            Description: null,
            Category_Id: null,
            Privilege_Type: null,  
            Reference1: null,
            Reference2: null,
            Reference3: null,
            Reference4: null,
        }
    });
    const editArticleModel = reactive({
        api: apiEndpoint.bcrm_platform +'/article/Edit',
        method: 'POST',
        payload: {
            Seq: null,
            Article_Id: null,
            Article_Title: null,
            Article_Content_TH: null,
            Article_Content_EN: null,
            Status: null,
            Article_Cover_Url: null,
            Square_Image_Url: null,
            Valid_From: null,
            Valid_From_Time: null,
            Valid_Through: null,
            Valid_Through_Time: null,
            Remark: null,
            Description: null,
            Category_Id: null,
            Privilege_Type: null, 
            Reference1: null,
            Reference2: null,
            Reference3: null,
            Reference4: null, 
        }
    });
    const deleteArticleModel = reactive({
        api: apiEndpoint.bcrm_platform +'/article/Remove',
        method: 'POST',
        payload: {
            Article_Id: null
        } 
    });
    const articleSectionSortModel = reactive({
        api: apiEndpoint.bcrm_platform +'/article/SectionSort',
        method: 'POST',
        payload: {
            Article_Id: null,
            FromSeq: null,
            ToSeq: null
        }
    });
    const fetchInventoryModel = reactive({
        api: apiEndpoint.bcrm_platform +'/article/inventorylist',
        method: 'GET',
        payload: {}
    });
    const fetchRewardModel = reactive({
        api: apiEndpoint.bcrm_platform +'/article/rewardlist',
        method: 'POST',
        payload: {
            Inventory_Ref: null
        }
    })
    return{
        fetchArticleListModel,
        fetchArticleDetailModel,
        createArticleModel,
        editArticleModel,
        deleteArticleModel,
        articleSectionSortModel,
        fetchInventoryModel,
        fetchRewardModel
    }
}
export function articleCategoryModel(){
    const fetchArticleCategoryListModel = reactive({
        api: apiEndpoint.bcrm_platform +'/ArticleCategory/list',
        method: 'POST',
        payload: {
            Page: 1,
            Limit: 10,
            Filters: [],
            Ordering: []
        }
    });
    const fetchArticleCategoryDetail = reactive({
        api: apiEndpoint.bcrm_platform +'/ArticleCategory/Detail',
        method: 'POST',
        payload: {
            Category_Id: null
        }
    });
    const createArticleCategoryModel = reactive({
        api: apiEndpoint.bcrm_platform +'/ArticleCategory/Create',
        method: 'POST',
        payload: {
            Seq: null,
            Category_Name_TH: null,
            Category_Name_EN: null,
            Category_Active_Img: null,
            Category_Inactive_Img: null,
            Valid_From: null,
            Valid_Through: null,
            Status: null
        }
    });
    const editArticleCategoryModel = reactive({
        api: apiEndpoint.bcrm_platform +'/ArticleCategory/Edit',
        method: 'POST',
        payload: {
            Category_Id: null,
            Seq: null,
            Category_Name_TH: null,
            Category_Name_EN: null,
            Category_Active_Img: null,
            Category_Inactive_Img: null,
            Valid_From: null,
            Valid_Through: null,
            Status: null
        }
    });
    const deleteCategoryModel = reactive({
        api: apiEndpoint.bcrm_platform +'/ArticleCategory/Remove',
        method: 'POST',
        payload: {
            Category_Id: null
        }
    });
    const categorySectionSort = reactive({
        api: apiEndpoint.bcrm_platform +'/ArticleCategory/SectionSort',
        method: 'POST',
        payload: {
            Category_Id: null,
            FromSeq: null,
            ToSeq: null
        }
    });
    return {
        fetchArticleCategoryListModel,
        fetchArticleCategoryDetail,
        createArticleCategoryModel,
        editArticleCategoryModel,
        deleteCategoryModel,
        categorySectionSort
    }
}